import { styled } from '@mui/material/styles';
import { CompGroupLabelStyleProps } from './CompGroupLabel.types';
import { compGroupLabelClasses } from './constants';

export const Root = styled('div')<CompGroupLabelStyleProps>(({ color }) => ({
  display: 'inline-flex',
  flexShrink: 0,
  [`& .${compGroupLabelClasses.compGroupLabelInitials}`]: {
    border: `solid 1px ${color}`,
    color,
    marginRight: '0.3em',
    fontWeight: 'bold',
    padding: '0 0.1em',
    cursor: 'pointer',
    background: 'transparent',
    lineHeight: 1.2,
  },
}));
